import { Global, css } from "@emotion/react";
import { Typography } from "@zapier/design-system";
import { resetValue } from "./constants";

const blockElements = [
  "address",
  "article",
  "aside",
  "blockquote",
  "details",
  "dialog",
  "dd",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "hr",
  "li",
  "main",
  "nav",
  "ol",
  "p",
  "pre",
  "section",
  "table",
  "ul",
];

const styles = css`
  // Reset properties using 'all' keyword when available.
  @supports (all: ${resetValue}) {
    all: ${resetValue};
  }

  // Address Safari bug where 'color' doesn't inherit properly.
  // See https://bit.ly/2B7ofWm for details.
  * {
    -webkit-text-fill-color: currentColor;
    box-sizing: border-box;
  }

  svg {
    box-sizing: unset;
  }

  // Elements 'display: inline' by default depending on 'resetValue',
  // so ensure that block-level elements still display block. The qualifying
  // tag selector adds to specificity, but not enough to conflict with
  // component class selectors.
  ${blockElements.join(", ")} {
    all: ${resetValue};
    display: block;
  }

  a,
  label,
  button:not([disabled]) {
    cursor: pointer;
  }

  button {
    border: none;
    padding: 0;
  }

  *:focus {
    outline: none;
    border: none;
  }

  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }
  // Fixes the 'details-element-polyfill' breaking due to reset's specificity
  // winning out over the polyfill's styles
  details:not([open]) > *:not(summary) {
    display: none;
  }

  body,
  #__next,
  #__next > div {
    height: 100%;
  }

  body {
    ${Typography.base}
    margin: 0;
  }
`;

/**
 * This component provides global styles to reset all CSS properties
 * on our components so we don't have to deal with style conflicts from
 * external styles.
 *
 * This only needs to be rendered in an application once
 * ```jsx
 * <StylesReset />
 * ```
 *
 * And then components can opt-in using  the `isolateComponent` pragma
 */
export function StylesReset() {
  return <Global styles={styles} />;
}
